export default "__VITE_ASSET__t0np7glq__"